// usage like:
// >> import codes from "@/codes";
// >> codes.lookup("@nick");
// returns: "+66909588716"

const drivers = {
  "@dev": "+662222226", // for staging local host
  "@nick": "+66909588716",
  // "@art": "+66617936993", // old Art
  "@art": "+66613461642",
  "@kom": "+66652709533",
  // "@a": "+66906701929",
  "@a": "+66804232583",
  "@oiloil": "+66871922264",
  "@nattawit": "+66650042965",
  "@suriyun": "+66955151128",
  "@pong": "+66647076645",
  "@chai": "+66629659445",
  "@nick2": "+66913075336", // Nick from Fahtara Cafe
};

var codes = {
  lookup(txt) {
    var driver = drivers[txt];
    if (!driver) {
      if (txt[0] === "@") return txt; // could be a shop's special promo code
    }
    return driver; // will return null if key not exists
  },
};

export default codes;
